import { render, staticRenderFns } from "./workerDetail.vue?vue&type=template&id=67842268&scoped=true&"
import script from "./workerDetail.vue?vue&type=script&lang=js&"
export * from "./workerDetail.vue?vue&type=script&lang=js&"
import style0 from "./workerDetail.vue?vue&type=style&index=0&id=67842268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67842268",
  null
  
)

export default component.exports